import { Card } from "@material-ui/core";
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import * as React from "react";
import { ConnectedProps, connect } from "react-redux";
import ReduxLanguage from '../../components/ReduxLanguage';
import { IState } from "../../redux/store";
import { ICustomerContractInDTO } from "../../repository/jago/model/input/ICustomerContractInDTO";
import moment from 'moment';
import CustomerContractIconCustom from "../../components/CustomerContractIconCustom";
import translations from '../../translations/i18next';

const styles = createStyles({
  container: {
    display: 'flex',
    margin: 10,
    flexDirection: 'column',
    paddingBottom: 50,
  },
  headerContainer: {
    marginTop: 20,
    padding: 10,
    borderLeft: '3px solid #0D47A1',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  headerInner: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerTextContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  icon: {
    marginRight: 5,
    width: 25,
  },
  title: {
    fontWeight: 'bold'
  },
  sectionHeader: {
    fontWeight: 'bold'
  },
  sectionContent: {

  },
});

type IReduxProps = ConnectedProps<typeof connector>;

export interface ICustomerContractInfoDetailsViewProps extends WithStyles<typeof styles>{
}

export interface ICustomerContractInfoDetailsViewState {
}

export type ComponentProps = ICustomerContractInfoDetailsViewProps & IReduxProps;
class CustomerContractInfoDetailsView extends React.Component<ComponentProps, ICustomerContractInfoDetailsViewState> {

  private isCustomerContract(contract: any): contract is ICustomerContractInDTO {
    return contract && typeof contract === 'object' && contract.id !== undefined;
  }

  public render() {
    const { selectedCustomerContract, classes } = this.props;
    const hasContract = this.isCustomerContract(selectedCustomerContract);
    
    return (
      <div className={classes.container}>
        <Card className={classes.headerContainer}>
          <div className={classes.header}>
            <div className={classes.headerInner}>
              <CustomerContractIconCustom className={classes.icon} />
              <div className={classes.headerTextContainer}>
                <h2 className={classes.title}>{hasContract && selectedCustomerContract.name ? `${selectedCustomerContract.id} - ${selectedCustomerContract.name}` : ''}</h2>
              </div>
            </div>
          </div>
          <div style={{ marginTop: 15 }}>
            <h3 className={classes.sectionHeader}>{<ReduxLanguage languageKey={'credits.customerContractStatus'} />}</h3>
            <h3 className={classes.sectionContent}>{hasContract ? (selectedCustomerContract.status ? translations.t(`credits.customerContractStatus_${selectedCustomerContract.status}`) : '---') : '---'}</h3>
          </div>
          <div style={{ marginTop: 15 }}>
            <h3 className={classes.sectionHeader}>{<ReduxLanguage languageKey={'forms.customerName'} />}</h3>
            <h3 className={classes.sectionContent}>{hasContract ? (selectedCustomerContract.customerName || '---') : '---'}</h3>
          </div>
          <div style={{ marginTop: 15 }}>
            <h3 className={classes.sectionHeader}>{<ReduxLanguage languageKey={'credits.customerContractSigningDate'} />}</h3>
            <h3 className={classes.sectionContent}>{hasContract && selectedCustomerContract.signingDate ? moment(selectedCustomerContract.signingDate).format('DD/MM/YYYY') : '---'}</h3>
          </div>
          <div style={{ marginTop: 15 }}>
            <h3 className={classes.sectionHeader}>{<ReduxLanguage languageKey={'credits.customerContractExpirationDate'} />}</h3>
            <h3 className={classes.sectionContent}>{hasContract && selectedCustomerContract.expirationDate ? moment(selectedCustomerContract.expirationDate).format('DD/MM/YYYY') : '---'}</h3>
          </div>
          <div style={{ marginTop: 15 }}>
            <h3 className={classes.sectionHeader}>{<ReduxLanguage languageKey={'credits.customerContractActivationDate'} />}</h3>
            <h3 className={classes.sectionContent}>{hasContract && selectedCustomerContract.activationDate ? moment(selectedCustomerContract.activationDate).format('DD/MM/YYYY') : '---'}</h3>
          </div>
          <div style={{ marginTop: 15 }}>
            <h3 className={classes.sectionHeader}>{<ReduxLanguage languageKey={'credits.customerContractDeactivationDate'} />}</h3>
            <h3 className={classes.sectionContent}>{hasContract && selectedCustomerContract.deactivationDate ? moment(selectedCustomerContract.deactivationDate).format('DD/MM/YYYY') : '---'}</h3>
          </div>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state: IState) {
  return {
    language: state.settings.language,
    selectedCustomerContract: state.credits.customerContracts.selectedCustomerContract,
  };
}

const connector = connect(mapStateToProps);

export default connector(withStyles (styles)(CustomerContractInfoDetailsView as any));